import type { MotifComponent, MotifComponentProps } from '../../motif';
import { m } from '../../motif/m';

export const buttonFontVars = {
  '--button-desktop-font-size': m('--action-desktop-font-size'),
  '--button-desktop-font-letter-spacing': m('--action-desktop-font-letter-spacing'),
  '--button-desktop-font-line-height': m('--action-desktop-font-line-height'),
  '--button-desktop-font-weight': m('--action-desktop-font-weight'),
  '--button-mobile-font-size': m('--action-mobile-font-size'),
  '--button-mobile-font-letter-spacing': m('--action-mobile-font-letter-spacing'),
  '--button-mobile-font-line-height': m('--action-mobile-font-line-height'),
  '--button-mobile-font-weight': m('--action-mobile-font-weight'),
} as const;

export const buttonStandardVars = {
  // = `calc(${m('--spacing-s')} - 1px) calc(${m('--spacing-xl')} - 1px)`. Concrete for Figma tokens
  '--button-regular-padding': '11px 31px',
  // = `calc(${m('--spacing-xs')} - 1px) calc(${m('--spacing-m')} - 1px)`. Concrete for Figma tokens
  '--button-compact-padding': '7px 15px',
  '--button-border-width': '2px',
  '--button-border-radius': '64px',
  '--button-hover-shadow': m('--box-shadow-l'),
  '--button-active-shadow': m('--box-shadow-m'),
};

export const contrastBlackButtonVars: MotifComponentProps<MotifComponent.BUTTON> = {
  '--button-primary-bg-color': m('--primary-v100'),
  '--button-primary-hover-bg-color': m('--primary-v100'),
  '--button-primary-border-color': m('--primary-v100'),
  '--button-primary-hover-border-color': m('--primary-v100'),
  '--button-primary-hover-fg-color': m('--neutral-v700'),
  '--button-primary-fg-color': m('--neutral-v700'),
  '--button-secondary-bg-color': m('--neutral-v0'),
  '--button-secondary-hover-bg-color': m('--neutral-v0'),
  '--button-secondary-hover-fg-color': m('--neutral-v700'),
  '--button-secondary-border-color': m('--neutral-v0'),
  '--button-secondary-hover-border-color': m('--neutral-v0'),
  '--button-secondary-fg-color': m('--neutral-v700'),
  '--button-flat-fg-color': m('--neutral-v0'),
  ...buttonFontVars,
  ...buttonStandardVars,
} as const;

export const contrastYellowButtonVars: MotifComponentProps<MotifComponent.BUTTON> = {
  '--button-primary-bg-color': m('--neutral-v700'),
  '--button-primary-hover-bg-color': m('--neutral-v700'),
  '--button-primary-border-color': m('--neutral-v700'),
  '--button-primary-hover-border-color': m('--neutral-v700'),
  '--button-primary-hover-fg-color': m('--neutral-v0'),
  '--button-primary-fg-color': m('--neutral-v0'),
  '--button-secondary-bg-color': m('--neutral-v0'),
  '--button-secondary-hover-bg-color': m('--neutral-v0'),
  '--button-secondary-border-color': m('--neutral-v0'),
  '--button-secondary-hover-border-color': m('--neutral-v0'),
  '--button-secondary-hover-fg-color': m('--neutral-v700'),
  '--button-secondary-fg-color': m('--neutral-v700'),
  '--button-flat-fg-color': m('--neutral-v700'),
  ...buttonFontVars,
  ...buttonStandardVars,
} as const;

export const contrastWhiteButtonVars: MotifComponentProps<MotifComponent.BUTTON> = {
  '--button-primary-bg-color': m('--primary-v100'),
  '--button-primary-hover-bg-color': m('--primary-v100'),
  '--button-primary-border-color': m('--primary-v100'),
  '--button-primary-hover-border-color': m('--primary-v100'),
  '--button-primary-hover-fg-color': m('--neutral-v700'),
  '--button-primary-fg-color': m('--neutral-v700'),
  '--button-secondary-bg-color': m('--neutral-v700'),
  '--button-secondary-hover-bg-color': m('--neutral-v700'),
  '--button-secondary-border-color': m('--neutral-v700'),
  '--button-secondary-hover-border-color': m('--neutral-v700'),
  '--button-secondary-hover-fg-color': m('--neutral-v0'),
  '--button-secondary-fg-color': m('--neutral-v0'),
  '--button-flat-fg-color': m('--neutral-v700'),
  ...buttonFontVars,
  ...buttonStandardVars,
} as const;

export const contrastGrayButtonVars: MotifComponentProps<MotifComponent.BUTTON> = {
  '--button-primary-bg-color': m('--primary-v100'),
  '--button-primary-hover-bg-color': m('--primary-v100'),
  '--button-primary-border-color': m('--primary-v100'),
  '--button-primary-hover-border-color': m('--primary-v100'),
  '--button-primary-hover-fg-color': m('--neutral-v700'),
  '--button-primary-fg-color': m('--neutral-v700'),
  '--button-secondary-bg-color': m('--neutral-v0'),
  '--button-secondary-hover-bg-color': m('--neutral-v0'),
  '--button-secondary-border-color': m('--neutral-v0'),
  '--button-secondary-hover-border-color': m('--neutral-v0'),
  '--button-secondary-hover-fg-color': m('--neutral-v700'),
  '--button-secondary-fg-color': m('--neutral-v700'),
  '--button-flat-fg-color': m('--neutral-v700'),
  ...buttonFontVars,
  ...buttonStandardVars,
} as const;
